// 导入 Vuex store 实例（请根据你项目的实际路径调整）
// import store from '@/store/index.js';
import store from '@/store/index'
let socketD;
let session;
let MY_USR_CD;
let MY_USR_NM;
let MY_CLIENT_CD;

// 初始化连接
export async function initSocket() {
  if (session) return; // 避免重复初始化
  
  // Vue2 中动态导入模块的方式不变
  const module = await import('@noear/socket.d');
  socketD = module.SocketD; 
  
  // 从 Vuex store 中获取数据（替换 Pinia 的 useStore 调用）
  const client_dev = store.state.auth.CLIENT_CONFIG.client_dev;
  const client_type = store.state.auth.CLIENT_CONFIG.client_type;
  MY_CLIENT_CD = store.state.auth.CLIENT_CONFIG.client_cd;
  MY_USR_CD = store.state.auth.TOKEN_CONFIG.usr_cd;
  MY_USR_NM = store.state.auth.TOKEN_CONFIG.usr_nm;
  const client_gate = store.state.auth.CLIENT_CONFIG.client_gate;
  const RUN_ID = store.state.auth.TOKEN_CONFIG.run_id;

  console.log('★：0000000000000000000================', JSON.stringify(RUN_ID))

  const ipRegex = /\b(?:\d{1,3}\.){3}\d{1,3}\b/;
  const match = client_gate.match(ipRegex);

  // 拼接 WS 连接地址（逻辑不变）
  // let wsurl = "sd:ws://"+match+":28588/ws/msg?usr_cd=" + MY_USR_CD + "&usr_nm=" + MY_USR_NM + "&client_type=8"+ "&client_cd=" + MY_CLIENT_CD + "&client_dev=" + client_dev
  let wsurl = "sd:ws://"+match+":28588/ws/msg?run_id="+RUN_ID
  console.log('★：1111111111111111111================', wsurl)
  
  session = await socketD.createClient(wsurl)
    .listen(socketD.newEventListener()
      .doOnOpen((session) => {
        console.log('★：Ws Opened');
      })
      .doOn("/demo", (session, message) => {
        try {
          const data = JSON.parse(message.dataAsString());
          console.log('★：GotEvt /demo', data);
        } catch (error) {
          console.error('JSON解析错误', error);
        }
      })
      .doOnMessage((session, message) => {
        try {
          const data = JSON.parse(message.dataAsString());
          console.log('★：GotMsg================', JSON.stringify(data));
          // Vuex 中修改状态（替换 Pinia 的直接赋值）
          // store.commit('SET_CALL_OUT_MSG', data);
          store.commit('auth/SET_CALL_OUT_MSG', data)
        } catch (error) {
          console.error('JSON解析错误', error);
        }
      })
    )
    .open();
}
// 发送广播消息（所有用户接受）
export async function SendBoardCast(content) {  
  if (!session) {
    await initSocket();
  } 
  // 等待连接建立
  await new Promise(resolve => setTimeout(resolve, 500));
  let jsmgs={
    type:'broadcast',
    from:MY_USR_CD,
    to:'',
    content:content,
    timestamp:new Date().getTime()
  }
  const entity2 = socketD.newEntity(JSON.stringify(jsmgs)).metaPut("sender","noear");
  session.send("/treat", entity2);
}



export async function SendClientBoardCast(clientType,content) {  
  if (!session) {
    await initSocket();
  } 
  // 等待连接建立
  await new Promise(resolve => setTimeout(resolve, 500));
  let jsmgs={
    type:'clientbroadcast',
    from:MY_USR_CD,
    to:clientType,
    content:content,
    timestamp:new Date().getTime()
  }
  const entity2 = socketD.newEntity(JSON.stringify(jsmgs)).metaPut("sender","noear");
  session.send("/treat", entity2);
}

// 发送消息（与原函数兼容）
export async function SendMsg() {  
  if (!session) {
    await initSocket();
  }
  
  // 等待连接建立
  await new Promise(resolve => setTimeout(resolve, 500));
  
  let jsmgs = {
    type: 'chat',
    from: MY_USR_CD,
    to: '1',
    content: 'hahaha',
    timestamp: new Date()
  }
  
  const entity2 = socketD.newEntity(JSON.stringify(jsmgs)).metaPut("sender", "noear");
  session.send("/treat", entity2);
}

// 发送自定义消息
export async function sendCustomMessage(content, from = 'oko', to = 'oko') {
  if (!session) {
    await initSocket();
  }
  
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const message = {
    type: 'chat',
    from,
    to,
    content,
    timestamp: new Date().toISOString().replace('T', ' ').substring(0, 19)
  };
  
  const entity = socketD.newEntity(JSON.stringify(message)).metaPut("sender", "noear");
  session.send("/treat", entity);
}

// 断开连接
export async function closeSocket() {
  if (session) {
    await session.close();
    session = null;
    socketD = null;
  }
}